export const en = {
    add_service_error_message: 'Failed to add service',
    choose_tariff: 'Choose tariff',
};
